import { render, staticRenderFns } from "./Glosario.vue?vue&type=template&id=585397fb&scoped=true&"
import script from "./Glosario.vue?vue&type=script&lang=js&"
export * from "./Glosario.vue?vue&type=script&lang=js&"
import style0 from "./Glosario.vue?vue&type=style&index=0&id=585397fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585397fb",
  null
  
)

export default component.exports